import { FileControlExtension, IFileControlExtensionContext } from "tessa/ui/files";
import { UIContext, MenuAction } from "tessa/ui";
import { ICardModel } from "tessa/ui/cards";

export class ChangeFileMenu extends FileControlExtension {

    public openingMenu(context: IFileControlExtensionContext) {
        const editor = UIContext.current.cardEditor;
        let model: ICardModel;

        if (editor == null || !(model = editor.cardModel!) || model.cardType.name !== 'ArContract') {
            return;
        }

        // Убираем из меню все варианты создания файла.
        // @ts-ignore
        let fileList: FileList = context.control;
        if (fileList["cardTypeControl"].name === "Files") {
            ["Upload", "Scan", "PasteFromClipboard"].forEach(menuItemName => {
                let item: MenuAction | undefined;
                if (item = context.actions.find(i => i.name === menuItemName)) {
                    item.isCollapsed = true;
                }
            });
        }
    }
}